<template>
    <div style="height: 100%">
        <el-menu @select="handleSelect" :default-active="activeIndex" :unique-opened="true">
            <menutree v-for="item in menuList" :key="item.url" :menu="item" :showIcon="true"></menutree>
        </el-menu>
    </div>
</template>

<script>
    import menutree from '@/components/MenuTree'

    export default {
        components: {
            menutree,
        },
        name: 'LeftMenu',
        data () {
            return {
                activeIndex: '',
                menuList: []
            }
        },
        mounted () {
            this.uiLoadMenu()
            this.$bus.$on('setLeftActiveIndex', (activeIndex) => {
                this.activeIndex = activeIndex
            })
        },
        methods: {
            /**
             * @Description: 加载菜单
             * @author Lu Jie
             * @date 2020/7/1
             */
            uiLoadMenu () {
                let menus = this.$permission.GetLeftMenus()
                if (menus) {
                    this.menuList = menus
                } else {
                    this.menuList = menus
                }
            },
            /**
             * 菜单选择事件
             * @param key
             * @param keyPath
             */
            handleSelect (key, keyPath) {
                this.$emit('toggleChange')
                this.$bus.$emit('setActiveIndex', key)
            },
        },
    }
</script>

<style scoped>
    .el-menu {
        background-color: rgba(40, 49, 66, 1);
        border: none;
    }

    .el-menu-item {
        font-family: "微软雅黑 Regular", "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        color: #dde6fd;
    }

    /deep/ .el-submenu .el-submenu__title {
        font-family: "微软雅黑 Regular", "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        color: #dde6fd;
    }

    /deep/ .el-submenu .el-submenu__title i {
        font-size: 24px;
        color: #dde6fd;
        margin-right: 8px;
        /*padding-right: 10px;*/
    }

    /deep/ .el-submenu .el-submenu__icon-arrow {
        font-size: 18px !important;
    }

    /deep/ .el-menu-item i {
        font-size: 24px;
        color: #dde6fd !important;
        margin-right: 8px;
    }

    .el-menu-item:hover {
        background-color: transparent;
        color: white !important;
    }

    /deep/ .el-menu-item:hover > i {
        color: white !important;
    }

    /deep/ .el-menu-item:focus {
        background-color: rgba(179, 198, 252, 0.0980392156862745);
        color: white !important;
        border-left: 4px solid rgba(112, 151, 254, 1);
    }

    /deep/ .el-menu-item:focus > i {
        color: white !important;
    }

    /deep/ .el-submenu .el-submenu__title:hover {
        background-color: transparent;
        color: white !important;
    }

    /deep/ .el-submenu .el-submenu__title:hover > i {
        color: white !important;
    }

    /deep/ .el-submenu .el-menu-item {
        background-color: rgba(32, 42, 52, 1);
    }

    /* 测试 */
    /deep/ .el-submenu .el-submenu {
        background-color: rgba(32, 42, 52, 1);
    }

    /deep/ .el-submenu .el-menu-item {
        font-family: "微软雅黑 Regular", "微软雅黑";
        font-weight: 400;
        font-style: normal;
        font-size: 16px;
        color: #8999a9;
    }

    /deep/ .el-submenu .el-menu-item:hover {
        color: white !important;
    }

    /deep/ .el-submenu .el-menu-item:focus {
        /*background-color:rgba(179, 198, 252, 0.0980392156862745);*/
        /*background-color: rgba(179, 198, 252, 1);*/
        color: white !important;
        border-left: 4px solid rgba(112, 151, 254, 1);
    }

    /deep/ .el-submenu .el-menu-item:focus > i {
        color: white !important;
    }

    /deep/ .el-submenu .el-menu-item i {
        font-size: 18px;
        color: #8999a9;
    }

    /deep/ .el-submenu .el-menu-item:hover > i {
        color: white !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/LeftMenu.vue